import React, { Component } from 'react'

export default class TrafficCount extends Component {
    render() {
        return (
            <div>
                <h5>Traffic</h5>
            </div>
        )
    }
}
